import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { enum_api_uri } from "../utils/enum";
import axiosInstance from "./axiosInstance";

interface Request {
    limit: string;
    page: number;
    searchtxt: string;
}
export type DataListProps = {
    list_no: number;
    company: string;
    name: string;
    mobile: string;
    address: string;
    printer: string;
    w_date: string;
    result: number;
    result_text: string;
};

export interface ResponseData {
    limit: number;
    current_page: number;
    start_page: number;
    max_page: number;
    last_page: number;
    end_page: number;
    total_count: number;
    data_list: DataListProps[];
}

export const useGetConsoleQrSystem = ({ page, limit, searchtxt }: Request): UseQueryResult<ResponseData, Error> => {
    let url = enum_api_uri.get_console_qr_system_request;
    return useQuery({
        queryKey: ["useGetConsoleQrSystem", page, limit, searchtxt],
        queryFn: async () => {
            const response = await axiosInstance.get(url, {
                params: {
                    page,
                    limit,
                    search: "all_search",
                    searchtxt,
                },
            });
            return response.data.data;
        },
    });
};
